import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environment';

@Injectable({
  providedIn: 'root'
})
export class InitGuard implements CanActivate {
  #translate= inject(TranslateService);
  canActivate(): boolean {
    document.documentElement.lang = environment.lang;
    if (environment.lang == 'he') {
      document.documentElement.dir = 'rtl';
    }
    else {
      document.documentElement.dir = 'ltr';
    }
    this.#translate.setFallbackLang(environment.lang);
    this.changeFavicon(`/assets/images/header/questionnaireSite-${environment.client}-logo.svg`);
    return true;
  }

  changeFavicon(iconPath: string) {
    const link: HTMLLinkElement = document.querySelector('link[rel="icon"]') || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconPath;
    document.head.appendChild(link);
  }
}
